import { types, flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';

import TransactionsPaginator from './TransactionsPaginator';

export default types
  .model('BankAccount', {
    isLoading: false,
    error: types.maybeNull(types.string),

    id: types.number,
    created_at: types.maybe(types.string),
    updated_at: types.maybe(types.string),
    bank_account: types.maybe(types.string),
    user_name: types.maybeNull(types.string),
    user_email: types.maybeNull(types.string),
    logo_type: types.maybe(types.string),
    logo: types.maybeNull(types.string),
    is_verified: types.maybe(types.boolean),

    transactions: types.optional(TransactionsPaginator, {}),
  })
  .views(self => ({
    get logo_src() {
      return `data:image/jpeg;base64,${self.logo}`;
    },
  }))
  .actions(self => ({
    afterCreate() {
      self.transactions.bank_account_id = self.id;
      self.transactions.load();
    },
    load: flow(function* load() {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        try {
          response = yield makeRequest('admin-bank-account-data', null, { id: self.id });
          applySnapshot(self, { ...getSnapshot(self), ...response.data });
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),
  }));
